import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LocaleProvider } from "@/i18n/LocaleContext";
import { HolidayProvider } from "@/context/HolidayContext";
import KarfreitagGuard from "@/components/holidays/KarfreitagGuard";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { ImpressumPage, DatenschutzPage, AGBPage } from "@/pages/LegalPages";
import { CareerListPage, CareerDetailPage } from "@/pages/CareerPages";
import InquiryPortalPage from "@/pages/InquiryPortalPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const ProtectedRoute = ({ children }) => {  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#111315] flex items-center justify-center" data-testid="auth-loading">
        <div className="font-tech text-xs tracking-[0.3em] uppercase text-[var(--ci-grey)] animate-pulse">Authentifizierung…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <LocaleProvider>
            <HolidayProvider>
              <ScrollToTop />
              <KarfreitagGuard>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/en" element={<LandingPage />} />
                  <Route path="/impressum" element={<ImpressumPage />} />
                  <Route path="/datenschutz" element={<DatenschutzPage />} />
                  <Route path="/agb" element={<AGBPage />} />
                  <Route path="/karriere" element={<CareerListPage />} />
                  <Route path="/karriere/:slug" element={<CareerDetailPage />} />
                  <Route path="/anfrage-portal" element={<InquiryPortalPage />} />
                  <Route path="/en/inquiry-portal" element={<InquiryPortalPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </KarfreitagGuard>
            </HolidayProvider>
          </LocaleProvider>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
